import { ReactNode } from "react";
import { Toast } from "react-hot-toast";
import { PiSealWarningFill } from "react-icons/pi";

type Props = {
  t: Toast;
  message: ReactNode;
};
export const WarrningToast = ({ t, message }: Props) => {
  return (
    <div
      className={`${
        t.visible ? "animate-enter" : "animate-leave"
      } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
    >
      <div className="flex  p-4">
        <PiSealWarningFill className="text-orange-500  text-2xl me-4" />

        <div> {message}</div>
      </div>
    </div>
  );
};
